(function () {
  if (window.__mimuSocialProofInitialized) return;
  window.__mimuSocialProofInitialized = true;

  var dialog = document.getElementById('MimuProofModal');
  if (!dialog) return;

  var body = dialog.querySelector('[data-mimu-proof-modal-body]');
  var prevButton = dialog.querySelector('[data-mimu-proof-prev]');
  var nextButton = dialog.querySelector('[data-mimu-proof-next]');
  var closeButton = dialog.querySelector('[data-mimu-proof-close]');
  var currentGroup = '';
  var currentIndex = 0;
  var groupTriggers = [];
  var touchStartX = null;

  function getGroupTriggers(group) {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mimu-proof-trigger]')).filter(function (trigger) {
      return trigger.getAttribute('data-mimu-proof-group') === group;
    });
  }

  function pauseVideos() {
    body.querySelectorAll('video').forEach(function (video) {
      try { video.pause(); } catch (e) {}
    });
  }

  function renderTrigger(trigger) {
    if (!trigger) return;
    pauseVideos();
    var templateId = trigger.getAttribute('data-mimu-proof-template');
    var template = templateId ? document.getElementById(templateId) : null;
    body.innerHTML = '';
    if (template && template.content) {
      body.appendChild(template.content.cloneNode(true));
    }

    currentIndex = Math.max(0, groupTriggers.indexOf(trigger));
    var showNavigation = groupTriggers.length > 1;
    prevButton.hidden = !showNavigation;
    nextButton.hidden = !showNavigation;
  }

  function openProof(trigger) {
    currentGroup = trigger.getAttribute('data-mimu-proof-group') || '';
    groupTriggers = getGroupTriggers(currentGroup);
    renderTrigger(trigger);

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    document.body.classList.add('mimu-proof-modal-open');
    window.setTimeout(function () {
      if (closeButton) closeButton.focus();
    }, 20);
  }

  function closeProof() {
    pauseVideos();
    body.innerHTML = '';
    document.body.classList.remove('mimu-proof-modal-open');
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function move(delta) {
    if (groupTriggers.length < 2) return;
    currentIndex = (currentIndex + delta + groupTriggers.length) % groupTriggers.length;
    renderTrigger(groupTriggers[currentIndex]);
  }

  document.addEventListener('click', function (event) {
    var scrollControl = event.target.closest('[data-mimu-proof-scroll-prev], [data-mimu-proof-scroll-next]');
    if (scrollControl) {
      event.preventDefault();
      var proofSection = scrollControl.closest('.mimu-social-proof');
      var scroller = proofSection ? proofSection.querySelector('[data-mimu-proof-scroll]') : null;
      if (scroller) {
        var firstCard = scroller.querySelector('.mimu-proof-card');
        var distance = firstCard ? firstCard.getBoundingClientRect().width + 18 : scroller.clientWidth * 0.85;
        var direction = scrollControl.hasAttribute('data-mimu-proof-scroll-prev') ? -1 : 1;
        scroller.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }
      return;
    }

    var trigger = event.target.closest('[data-mimu-proof-trigger]');
    if (trigger) {
      event.preventDefault();
      openProof(trigger);
      return;
    }

    if (event.target.closest('[data-mimu-proof-close]')) {
      event.preventDefault();
      closeProof();
      return;
    }

    if (event.target.closest('[data-mimu-proof-prev]')) {
      event.preventDefault();
      move(-1);
      return;
    }

    if (event.target.closest('[data-mimu-proof-next]')) {
      event.preventDefault();
      move(1);
    }
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) closeProof();
  });

  dialog.addEventListener('close', function () {
    pauseVideos();
    body.innerHTML = '';
    document.body.classList.remove('mimu-proof-modal-open');
  });

  document.addEventListener('keydown', function (event) {
    if (!dialog.open) return;
    if (event.key === 'ArrowLeft') move(-1);
    if (event.key === 'ArrowRight') move(1);
    if (event.key === 'Escape') closeProof();
  });

  body.addEventListener('touchstart', function (event) {
    touchStartX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : null;
  }, { passive: true });

  body.addEventListener('touchend', function (event) {
    if (touchStartX === null || !event.changedTouches || !event.changedTouches[0]) return;
    var delta = event.changedTouches[0].clientX - touchStartX;
    touchStartX = null;
    if (Math.abs(delta) < 55) return;
    move(delta > 0 ? -1 : 1);
  }, { passive: true });
})();
